import React from 'react';
import DevicesTable from './DevicesTable';
import Content from '../dashboard/Content';

import './Device.scss';

export default class Devices extends React.Component {

  render() {
    return (
      <Content title="خانه / لیست دستگاه‌ها">
        <DevicesTable />
      </Content>
    );
  }

}
